import {DOMNode, domToReact, Element} from "html-react-parser";

/**
 * Helper to be used with html-react-parser parse, to remove the outer p tag element.
 */
export const stripOuterParagraph = {
  replace: (domNode: DOMNode) => {
    const isElement = (node: DOMNode): node is Element => node.type === 'tag';
    if (isElement(domNode) && domNode.name === "p") {
      return <>{domToReact(domNode.children, {})}</>;
    }
  },
};

